import { stormScenarios } from "../config/stormScenarios";

// initial state
export const defaultReducedStormOptionsTwo = {
 selectedAdaptation: undefined,
 selectedSLR: undefined,
 selectedRainfallAmount: undefined,
 selectedStormSurge: undefined,
 selectedGroundwaterConditions: undefined,
 availableSLR: [],
 availableRain: [],
 availableStormSurges: [],
 availableGroundwater: [],
 finalSelection: [],
};

// reducer function
const reduceStormOptionsTwo = (state, action) => {
 if (!!!state) state = defaultReducedStormOptionsTwo;
 switch (action.type) {
  case "setSelectedAdaptation": {
   return {
    selectedAdaptation: action.value,
    selectedSLR: undefined,
    selectedStormSurge: undefined,
    selectedRainfallAmount: undefined,
    selectedGroundwaterConditions: undefined,
    availableSLR:
     // if "Tier 1" is selected, show "2.0 ft" and "Current" SLR options only (not "3.3 ft")
     //  action.value === "Tier 1"
     //   ? stormScenarios.filter(
     //      (e) => e.adaptationScenario === action.value && e.SLR !== "3.3 ft"
     //     )
     //   : // : // if "Tier 2" is selected, show "3.3 ft" and "Current" SLR options only (not "2.0 ft")
     // action.value === "Tier 2"
     // ? stormScenarios.filter(
     //    (e) => e.adaptationScenario === action.value && e.SLR !== "2.0 ft"
     //   )
     stormScenarios.filter((e) => e.adaptationScenario === action.value),
    availableRain: [],
    availableStormSurges: [],
    availableGroundwater: [],
    finalSelection: [],
    // availableAdaptation: [],
   };
  }
  case "setSelectedSLR": {
   return {
    selectedAdaptation: state.selectedAdaptation,
    selectedSLR: action.value,
    selectedRainfallAmount: undefined,
    selectedStormSurge: undefined,
    selectedGroundwaterConditions: undefined,
    availableSLR: state.availableSLR,
    availableRain: state.availableSLR.filter((e) => e.SLR === action.value),
    availableStormSurges: [],
    availableGroundwater: [],
    finalSelection: [],
    // availableAdaptation: [],
   };
  }
  case "setSelectedRainfallAmount": {
   return {
    selectedAdaptation: state.selectedAdaptation,
    selectedSLR: state.selectedSLR,
    selectedRainfallAmount: action.value,
    selectedStormSurge: undefined,
    selectedGroundwaterConditions: undefined,
    availableSLR: state.availableSLR,
    availableRain: state.availableRain,
    availableStormSurges: state.availableRain.filter(
     (e) => e.rainfallAmount === action.value
    ),
    availableGroundwater: [],
    finalSelection: [],
    // availableAdaptation: [],
   };
  }
  case "setSelectedStormSurge": {
   return {
    selectedAdaptation: state.selectedAdaptation,
    selectedSLR: state.selectedSLR,
    selectedRainfallAmount: state.selectedRainfallAmount,
    selectedStormSurge: action.value,
    selectedGroundwaterConditions: undefined,
    availableSLR: state.availableSLR,
    availableRain: state.availableRain,
    availableStormSurges: state.availableStormSurges,
    availableGroundwater: state.availableStormSurges.filter(
     (e) => e.stormSurge === action.value
    ),
    finalSelection: [],
    // availableAdaptation: [],
   };
  }
  case "setSelectedGroundwaterConditions": {
   return {
    selectedAdaptation: state.selectedAdaptation,
    selectedSLR: state.selectedSLR,
    selectedRainfallAmount: state.selectedRainfallAmount,
    selectedStormSurge: state.selectedStormSurge,
    selectedGroundwaterConditions: action.value,
    availableSLR: state.availableSLR,
    availableRain: state.availableRain,
    availableStormSurges: state.availableStormSurges,
    availableGroundwater: state.availableGroundwater,
    // availableAdaptation: state.availableGroundwater.filter(
    //  (e) => e.groudwaterConditions === action.value
    // ),
    finalSelection: state.availableGroundwater.filter(
     (e) => e.groudwaterConditions === action.value
    ),
   };
  }
  default: {
   return state;
  }
 }
};

export default reduceStormOptionsTwo;
